import ConnectedContainer from "components/container/ConnectedContainer.tsx";
import {useAppDispatch, useAppSelector} from "config/store";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import Button from "components/atom/button/Button.tsx";
import {authActions} from "config/store/modules/auth.ts";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax, {resetSessionId} from "config/ajax.ts";
import {UserType} from "globals/types/models.ts";
import {useTranslation} from "react-i18next";
import {STORAGE_WELCOME_MODAL_KEY} from "utils/data/global.ts";

function MeDeletionPage() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const currentUser: UserType | null = useAppSelector(state => state.auth.user)

    const deleteAccount = useCallback(async () => {
        const [_, err] = await tryAsyncFunc(ajax.delete(`/connected/me`))

        if (err) {
            return
        }

        dispatch(authActions.setJwt(null))
        dispatch(authActions.setUser(null))
        resetSessionId()
        window.localStorage.removeItem(STORAGE_WELCOME_MODAL_KEY)
        navigate({pathname: '/map', hash: '#/auth/login'})
    }, [dispatch, navigate])

    if (!currentUser) {
        return null;
    }

    return (
        <ConnectedContainer title={t('menu.deleteMyAccount')}>
            <div className="mx-auto w-full md:max-w-[506px]">
                <div className="flex w-full flex-col items-center justify-center gap-4">
                    <p className="text-lg font-normal text-gray-600">
                        {t('user.confirmDeleteTitle')}
                        <br/>
                        <br/>
                        {t('user.confirmDeleteTitle2')}
                    </p>
                    <Button className="w-full" style="red" onClick={deleteAccount}>
                        {t('delete')}
                    </Button>
                </div>
            </div>
        </ConnectedContainer>

    )
}

export default MeDeletionPage
